(() => {
  let widgetPromise;
  function loadWidget() {
    if (window.YQV5) return Promise.resolve(window.YQV5);
    if (!widgetPromise) widgetPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://www.17track.net/externalcall.js';
      script.async = true;
      const timer = setTimeout(() => { script.remove(); reject(new Error('Tracking service timed out')); }, 15000);
      script.onload = () => { clearTimeout(timer); window.YQV5 ? resolve(window.YQV5) : reject(new Error('Tracking unavailable')); };
      script.onerror = () => { clearTimeout(timer); script.remove(); reject(new Error('Tracking unavailable')); };
      document.head.append(script);
    }).catch(error => { widgetPromise = null; throw error; });
    return widgetPromise;
  }
  if (customElements.get('kr-track-order')) return;
  customElements.define('kr-track-order', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const tabs = [...this.querySelectorAll('[role="tab"]')];
      const select = index => tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
        this.querySelector('#' + tab.getAttribute('aria-controls')).hidden = i !== index;
      });
      this.querySelector('[data-tabs]').hidden = false;
      select(0);
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(index));
        tab.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? 1 : 1 - index;
          select(next); tabs[next].focus();
        });
      });
      this.querySelector('[data-shipment-form]').addEventListener('submit', async event => {
        event.preventDefault();
        const form = event.currentTarget;
        const input = form.elements.tracking;
        const number = input.value.trim();
        if (!number) { input.focus(); return; }
        const button = form.querySelector('button');
        const message = this.querySelector('[data-tracking-message]');
        button.disabled = true;
        message.textContent = 'Loading shipment updates…';
        try {
          const widget = await loadWidget();
          if (!this.isConnected) return;
          widget.trackSingle({ YQ_ContainerId: this.querySelector('[data-tracking-results]').id, YQ_Height: 560, YQ_Fc: '0', YQ_Lang: 'en', YQ_Num: number });
          this.querySelector('[data-tracking-results]').querySelector?.('iframe')?.setAttribute('title', 'Shipment tracking updates from 17TRACK');
          message.textContent = 'Shipment updates provided by 17TRACK.';
        } catch (error) {
          message.textContent = 'Tracking could not load. Please try again or ';
          const link = document.createElement('a');
          link.href = 'https://www.17track.net/en#nums=' + encodeURIComponent(number);
          link.textContent = 'open 17TRACK';
          link.target = '_blank'; link.rel = 'noopener noreferrer';
          message.append(link);
        } finally { button.disabled = false; }
      });
    }
  });
})();
